import type {ReactElement} from 'react';
import styles from './pulsating-three-dots.module.scss';

interface PulsatingThreeDotsProps {
  className?: string;
}
export function PulsatingThreeDots({className = ''}: PulsatingThreeDotsProps): ReactElement {
  return (
    <div className={`${styles.dotsContainer} ${className}`} aria-hidden="true">
      <span className={`radius-round ${styles.dot} ${styles.dot1}`} />
      <span className={`radius-round ${styles.dot} ${styles.dot2}`} />
      <span className={`radius-round ${styles.dot} ${styles.dot3}`} />
    </div>
  );
}
